// extracted by mini-css-extract-plugin
export var shake = "_v-0";